import { useTypewriterReveal } from "@/hooks/useTypewriterReveal";
import remend from "remend";

import { AnimatedMessageContentView } from "./AnimatedMessageContentView";

interface AnimatedMessageContentProps {
  content: string;
  /** True only while this specific message is actively streaming in. */
  isLive: boolean;
}

/** Renders assistant markdown at a constant reveal rate while live, instantly otherwise. */
export const AnimatedMessageContent = ({ content, isLive }: AnimatedMessageContentProps) => {
  const revealedText = useTypewriterReveal(content, isLive);
  const isRevealing = revealedText.length < content.length;

  return <AnimatedMessageContentView content={remend(revealedText)} isRevealing={isRevealing} />;
};
